/* ★ HASIL AGENT → SATU KAD, MEDAN DEMI MEDAN (2026-10-13)
 *
 * Larian pukal Agent Saya / scrape FLOWNITY (`runSmartAgent`, WorkspaceView.jsx)
 * memegang salinan SEMUA kad yang diambil semasa Run ditekan (`working`). Dahulu,
 * setiap kali satu kad siap, seluruh salinan itu dipulangkan ke state dan disimpan
 * (`setProducts(working)` + `saveToCloud(working)`), jadi apa-apa yang ditulis
 * pihak lain SELEPAS Run ditekan — robot Flow di browser lain (video, poster,
 * status, log, link collection), larian Agent di tab kedua — ditimpa balik dengan
 * salinan lama, senyap. Ditangkap hidup pada akaun pelanggan 13 Okt 2026: 5 video
 * hilang daripada kad 2 saat selepas Agent menyiapkan kad LAIN.
 *
 * Fail ini mengira APA yang larian Agent sendiri ubah pada kad itu (beza antara
 * salinan sebelum dan selepas giliran kad), supaya hanya medan itu yang dipulangkan
 * ke state dan ditulis ke cloud (utils/simpanHasilAgent.js).
 *
 * ⛔ Fungsi di sini TULEN (tiada import) — diuji dengan
 *    `node --test src/utils/hasilAgentKad.test.js`.
 */

const objekBiasa = (v) => !!v && typeof v === 'object' && !Array.isArray(v);

/**
 * Beza satu kad: salinan sebelum giliran (`sebelum`) lwn selepas (`selepas`).
 *
 * @returns {null | {
 *   medan:   Record<string, any>,                 // medan aras-atas yang berubah (tanpa prompts/logs)
 *   prompts: Record<string, Record<string, any>>, // set → medan yang berubah sahaja
 *   promptsPenuh: object | null,                  // prompts penuh selepas giliran (untuk state)
 *   logBaru: string[],                            // baris log yang DITAMBAH giliran ini
 * }}  null = larian tidak mengubah apa-apa pada kad ini.
 */
export function kiraHasilAgent(sebelum, selepas) {
    if (!objekBiasa(selepas)) return null;
    const lama = objekBiasa(sebelum) ? sebelum : {};

    const medan = {};
    for (const k of Object.keys(selepas)) {
        if (k === 'prompts' || k === 'logs') continue;
        if (selepas[k] === lama[k] || selepas[k] === undefined) continue;
        medan[k] = selepas[k];
    }

    const prompts = {};
    const pLama = objekBiasa(lama.prompts) ? lama.prompts : {};
    const pBaru = objekBiasa(selepas.prompts) ? selepas.prompts : null;
    const promptsBerubah = !!pBaru && pBaru !== lama.prompts;
    if (promptsBerubah) {
        for (const [setKey, setBaru] of Object.entries(pBaru)) {
            if (!objekBiasa(setBaru)) continue;
            const setLama = objekBiasa(pLama[setKey]) ? pLama[setKey] : {};
            for (const [f, v] of Object.entries(setBaru)) {
                if (v === undefined || v === setLama[f]) continue;
                if (!prompts[setKey]) prompts[setKey] = {};
                prompts[setKey][f] = v;
            }
        }
    }

    const logLama = Array.isArray(lama.logs) ? lama.logs : [];
    const logSelepas = Array.isArray(selepas.logs) ? selepas.logs : [];
    const logBaru = logSelepas.slice(logLama.length).filter(l => typeof l === 'string' && l);

    if (!Object.keys(medan).length && !Object.keys(prompts).length && !logBaru.length) return null;
    return { medan, prompts, promptsPenuh: promptsBerubah ? pBaru : null, logBaru };
}

/**
 * Pulangkan hasil ke kad dalam state TERKINI (bukan salinan larian): medan yang
 * larian tidak sentuh — video, poster, status, link collection, log robot — kekal
 * seperti yang ada sekarang.
 */
export function terapHasilAgent(kadSemasa, hasil) {
    if (!objekBiasa(kadSemasa) || !hasil) return kadSemasa;
    const out = { ...kadSemasa, ...hasil.medan };

    if (hasil.promptsPenuh) {
        const semasa = objekBiasa(kadSemasa.prompts) ? kadSemasa.prompts : {};
        const gabung = { ...semasa };
        for (const [setKey, setPenuh] of Object.entries(hasil.promptsPenuh)) {
            if (!objekBiasa(setPenuh)) { if (!(setKey in gabung)) gabung[setKey] = setPenuh; continue; }
            const setSemasa = objekBiasa(semasa[setKey]) ? semasa[setKey] : {};
            const ubah = hasil.prompts[setKey] || {};
            /* Tertib: teks penuh larian (asas) → nilai TERKINI kad (video/poster yang
               baru ditulis robot menang) → medan yang larian ini memang ubah. */
            gabung[setKey] = { ...setPenuh, ...setSemasa, ...ubah };
        }
        out.prompts = gabung;
    }

    if (hasil.logBaru.length) {
        out.logs = [...(Array.isArray(kadSemasa.logs) ? kadSemasa.logs : []), ...hasil.logBaru];
    }
    return out;
}
